import { html } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import componentStyles from './list.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

export default class List extends OutlineElement {
  static styles = [super.styles, componentStyles];

  static get properties() {
    return {
      title: { type: String },
      ordered: { type: Boolean },
      items: { type: Array },
      variant: { type: String },
    };
  }

  constructor() {
    super();
    this.ordered = false;
    this.variant = 'default';
  }

  render() {
    // return nothing if no items present
    if (!this.items) {
      return html``;
    }

    const listItems = this.items.map(item => html`<li>${item}</li>`);

    const classes = classMap({
      list: true,
      [`list--${this.variant}`]: !!this.variant,
    });

    return html`
        ${
          (this.title &&
            html` <div class="list__title">${this.title}</div> `) ||
          ''
        }
        ${
          this.ordered
            ? html`
                <ol class="${classes}">
                  ${listItems}
                </ol>
              `
            : html`
                <ul class="${classes}">
                  ${listItems}
                </ul>
              `
        }
      </div>
    `;
  }
}
customElements.define('hf-list', List);
